package com.shadowings.gero.data.datasource

import com.shadowings.gero.data.lessons.DistractorPool
import com.shadowings.gero.data.lessons.chapter1.famousNames
import com.shadowings.gero.data.lessons.chapter1.getChap1ChatContent
import com.shadowings.gero.data.lessons.chapter1.getFamousNames
import com.shadowings.gero.data.lessons.chapter1.getFamousNamesQuiz
import com.shadowings.gero.data.lessons.chapter1.getIntroHieroglyphs2Content
import com.shadowings.gero.data.lessons.chapter1.getIntroHieroglyphs2QuizContent
import com.shadowings.gero.data.lessons.chapter1.getIntroductionHieroglyphsContent
import com.shadowings.gero.data.lessons.chapter1.getIntroductionHieroglyphsQuizContent
import com.shadowings.gero.data.lessons.chapter1.getUni1Content
import com.shadowings.gero.data.lessons.chapter1.getUni2Content
import com.shadowings.gero.data.lessons.chapter1.getUni_1QuizContent
import com.shadowings.gero.data.lessons.chapter1.getUni_2QuizContent
import com.shadowings.gero.data.lessons.chapter10.getEccoFattoContent
import com.shadowings.gero.data.lessons.chapter10.getEccoFattoQuizContent
import com.shadowings.gero.data.lessons.chapter10.getIlGenitivoDirettoContent
import com.shadowings.gero.data.lessons.chapter10.getIlGenitivoDirettoQuizContent
import com.shadowings.gero.data.lessons.chapter10.getIlGenitivoIndirettoContent
import com.shadowings.gero.data.lessons.chapter10.getIlGenitivoIndirettoQuizContent
import com.shadowings.gero.data.lessons.chapter10.getIlGrandeRitornoContent
import com.shadowings.gero.data.lessons.chapter10.getIlGrandeRitornoQuizContent
import com.shadowings.gero.data.lessons.chapter10.getIlTemaVerbaleSdmFContent
import com.shadowings.gero.data.lessons.chapter10.getIlTemaVerbaleSdmFQuizContent
import com.shadowings.gero.data.lessons.chapter10.getLaFormaVsoContent
import com.shadowings.gero.data.lessons.chapter10.getLaFormaVsoQuizContent
import com.shadowings.gero.data.lessons.chapter10.getLaTeoriaContent
import com.shadowings.gero.data.lessons.chapter10.getLaTeoriaQuizContent
import com.shadowings.gero.data.lessons.chapter10.getLeFrasiAvverbialiContent
import com.shadowings.gero.data.lessons.chapter10.getLeFrasiAvverbialiQuizContent
import com.shadowings.gero.data.lessons.chapter10.getVerbiEParticipiContent
import com.shadowings.gero.data.lessons.chapter10.getVerbiEParticipiQuizContent
import com.shadowings.gero.data.lessons.chapter11.getComplementiComplessiContent
import com.shadowings.gero.data.lessons.chapter11.getComplementiComplessiQuizContent
import com.shadowings.gero.data.lessons.chapter11.getFrasiComplOggettoContent
import com.shadowings.gero.data.lessons.chapter11.getFrasiComplOggettoQuizContent
import com.shadowings.gero.data.lessons.chapter11.getFrasiConPronomiContent
import com.shadowings.gero.data.lessons.chapter11.getFrasiConPronomiQuizContent
import com.shadowings.gero.data.lessons.chapter11.getFrasiConSoggettoContent
import com.shadowings.gero.data.lessons.chapter11.getFrasiConSoggettoQuizContent
import com.shadowings.gero.data.lessons.chapter11.getLInfinitoContent
import com.shadowings.gero.data.lessons.chapter11.getLInfinitoQuizContent
import com.shadowings.gero.data.lessons.chapter11.getLaPazienzaEFinitaContent
import com.shadowings.gero.data.lessons.chapter11.getLaPazienzaEFinitaQuizContent
import com.shadowings.gero.data.lessons.chapter11.getRecapFrasiPseudoverbaliContent
import com.shadowings.gero.data.lessons.chapter11.getRecapFrasiPseudoverbaliQuizContent
import com.shadowings.gero.data.lessons.chapter11.getUnaDefinizioneContent
import com.shadowings.gero.data.lessons.chapter11.getUnaDefinizioneQuizContent
import com.shadowings.gero.data.lessons.chapter11.getVerbiSostantivatiContent
import com.shadowings.gero.data.lessons.chapter11.getVerbiSostantivatiQuizContent
import com.shadowings.gero.data.lessons.chapter12.getHieroFamigliaSocietaContent
import com.shadowings.gero.data.lessons.chapter12.getHieroFamigliaSocietaQuizContent
import com.shadowings.gero.data.lessons.chapter12.getVocabFamigliaSocietaContent
import com.shadowings.gero.data.lessons.chapter12.getVocabFamigliaSocietaQuizContent
import com.shadowings.gero.data.lessons.chapter12.getHieroVerbiVariContent
import com.shadowings.gero.data.lessons.chapter12.getHieroVerbiVariQuizContent
import com.shadowings.gero.data.lessons.chapter12.getVocabVerbiVariContent
import com.shadowings.gero.data.lessons.chapter12.getVocabVerbiVariQuizContent
import com.shadowings.gero.data.lessons.chapter12.getHieroOggettiSacriContent
import com.shadowings.gero.data.lessons.chapter12.getHieroOggettiSacriQuizContent
import com.shadowings.gero.data.lessons.chapter12.getVocabOggettiSacriContent
import com.shadowings.gero.data.lessons.chapter12.getVocabOggettiSacriQuizContent
import com.shadowings.gero.data.lessons.chapter12.getHieroDeiSovraniContent
import com.shadowings.gero.data.lessons.chapter12.getHieroDeiSovraniQuizContent
import com.shadowings.gero.data.lessons.chapter12.getVocabDeiSovraniContent
import com.shadowings.gero.data.lessons.chapter12.getVocabDeiSovraniQuizContent
import com.shadowings.gero.data.lessons.chapter12.getTorniamoAllaGrammaticaContent
import com.shadowings.gero.data.lessons.chapter12.getTorniamoAllaGrammaticaQuizContent
import com.shadowings.gero.data.lessons.chapter13.getLePreposizioniContent
import com.shadowings.gero.data.lessons.chapter13.getLePreposizioniQuizContent
import com.shadowings.gero.data.lessons.chapter13.getParoleDiLuoghiContent
import com.shadowings.gero.data.lessons.chapter13.getParoleDiLuoghiQuizContent
import com.shadowings.gero.data.lessons.chapter13.getPreposizioneHrContent
import com.shadowings.gero.data.lessons.chapter13.getPreposizioneHrQuizContent
import com.shadowings.gero.data.lessons.chapter13.getPreposizioneMLocativaContent
import com.shadowings.gero.data.lessons.chapter13.getPreposizioneMLocativaQuizContent
import com.shadowings.gero.data.lessons.chapter13.getParoleDelTempoContent
import com.shadowings.gero.data.lessons.chapter13.getParoleDelTempoQuizContent
import com.shadowings.gero.data.lessons.chapter13.getPreposizioneDrContent
import com.shadowings.gero.data.lessons.chapter13.getPreposizioneDrQuizContent
import com.shadowings.gero.data.lessons.chapter13.getLaFraseMisteriosaContent
import com.shadowings.gero.data.lessons.chapter13.getLaFraseMisteriosaQuizContent
import com.shadowings.gero.data.lessons.chapter14.getLaParticellaNiContent
import com.shadowings.gero.data.lessons.chapter14.getLaParticellaNiQuizContent
import com.shadowings.gero.data.lessons.chapter14.getIlVerboMaIContent
import com.shadowings.gero.data.lessons.chapter14.getIlVerboMaIQuizContent
import com.shadowings.gero.data.lessons.chapter14.getMiTiSrwContent
import com.shadowings.gero.data.lessons.chapter14.getMiTiSrwQuizContent
import com.shadowings.gero.data.lessons.chapter14.getIlDimostrativoPnContent
import com.shadowings.gero.data.lessons.chapter14.getIlDimostrativoPnQuizContent
import com.shadowings.gero.data.lessons.chapter14.getRieccoloDiNuovoContent
import com.shadowings.gero.data.lessons.chapter14.getRieccoloDiNuovoQuizContent
import com.shadowings.gero.data.lessons.chapter14.getIlSegretoDellaPiramideContent
import com.shadowings.gero.data.lessons.chapter14.getIlSegretoDellaPiramideQuizContent
import com.shadowings.gero.data.lessons.chapter16.getAggettiviGenereContent
import com.shadowings.gero.data.lessons.chapter16.getCambioDiRottaContent
import com.shadowings.gero.data.lessons.chapter16.getCambioDiRottaQuizContent
import com.shadowings.gero.data.lessons.chapter16.getAggettiviGenereQuizContent
import com.shadowings.gero.data.lessons.chapter16.getAggettiviPluraleQuizContent
import com.shadowings.gero.data.lessons.chapter16.getScortaDiAggettiviContent
import com.shadowings.gero.data.lessons.chapter16.getSegniDegliAggettiviContent
import com.shadowings.gero.data.lessons.chapter16.getSegniDegliAggettiviQuizContent
import com.shadowings.gero.data.lessons.chapter16.getScortaDiAggettiviQuizContent
import com.shadowings.gero.data.lessons.chapter16.getAggettiviPluraleContent
import com.shadowings.gero.data.lessons.chapter16.getAggettivoSostantivatoContent
import com.shadowings.gero.data.lessons.chapter16.getAggettivoSostantivatoQuizContent
import com.shadowings.gero.data.lessons.chapter16.getRipassinoAggettiviContent
import com.shadowings.gero.data.lessons.chapter16.getRipassinoAggettiviQuizContent
import com.shadowings.gero.data.lessons.chapter16.getPossessivoSuffissoContent
import com.shadowings.gero.data.lessons.chapter16.getPossessivoSuffissoQuizContent
import com.shadowings.gero.data.lessons.chapter17.getSdmFCongiuntivoContent
import com.shadowings.gero.data.lessons.chapter16.getInViaggioSulNiloContent
import com.shadowings.gero.data.lessons.chapter16.getInViaggioSulNiloQuizContent
import com.shadowings.gero.data.lessons.chapter15.getNomiImportantiContent
import com.shadowings.gero.data.lessons.chapter15.getNomiImportantiQuizContent
import com.shadowings.gero.data.lessons.chapter15.nomiImportantiQuizWordIds
import com.shadowings.gero.data.lessons.chapter15.getSignificatoDeiNomiContent
import com.shadowings.gero.data.lessons.chapter15.getSignificatoDeiNomiQuizContent
import com.shadowings.gero.data.lessons.chapter15.getNomiNomiNomiContent
import com.shadowings.gero.data.lessons.chapter15.getNomiNomiNomiImageQuizContent
import com.shadowings.gero.data.lessons.chapter15.getNomiNomiNomiQuizContent
import com.shadowings.gero.data.lessons.chapter15.nomiNomiNomiQuizWordIds
import com.shadowings.gero.data.lessons.chapter15.getTraduciamoINomiContent
import com.shadowings.gero.data.lessons.chapter15.getTraduciamoINomiImageQuizContent
import com.shadowings.gero.data.lessons.chapter15.getTraduciamoINomiQuizContent
import com.shadowings.gero.data.lessons.chapter15.traduciamoINomiQuizWordIds
import com.shadowings.gero.data.lessons.chapter15.getNomiEAggettivi1Content
import com.shadowings.gero.data.lessons.chapter15.getNomiEAggettivi1QuizContent
import com.shadowings.gero.data.lessons.chapter15.getSegniVariContent
import com.shadowings.gero.data.lessons.chapter15.getSegniVariQuizContent
import com.shadowings.gero.data.lessons.chapter15.getUnAttimoContent
import com.shadowings.gero.data.lessons.chapter15.getUnAttimoQuizContent
import com.shadowings.gero.data.lessons.chapter15.getUnSeguaceEccellenteContent
import com.shadowings.gero.data.lessons.chapter15.getUnSeguaceEccellenteQuizContent
import com.shadowings.gero.data.lessons.chapter2.animalNames
import com.shadowings.gero.data.lessons.chapter2.foodNames
import com.shadowings.gero.data.lessons.chapter2.getChap2EOraContent
import com.shadowings.gero.data.lessons.chapter2.getHieroAnimalsContent
import com.shadowings.gero.data.lessons.chapter2.getHieroAnimalsQuizContent
import com.shadowings.gero.data.lessons.chapter2.getHieroFood2Content
import com.shadowings.gero.data.lessons.chapter2.getHieroFood2QuizContent
import com.shadowings.gero.data.lessons.chapter2.getHieroFoodContent
import com.shadowings.gero.data.lessons.chapter2.getHieroFoodQuizContent
import com.shadowings.gero.data.lessons.chapter2.getHieroHumansContent
import com.shadowings.gero.data.lessons.chapter2.getHieroHumansQuizContent
import com.shadowings.gero.data.lessons.chapter2.getNumberGenderContent
import com.shadowings.gero.data.lessons.chapter2.getNumberGenderQuizContent
import com.shadowings.gero.data.lessons.chapter2.getPhoneticComplementsContent
import com.shadowings.gero.data.lessons.chapter2.getPhoneticComplementsQuizContent
import com.shadowings.gero.data.lessons.chapter2.getVocabAnimalsContent
import com.shadowings.gero.data.lessons.chapter2.getVocabAnimalsQuizContent
import com.shadowings.gero.data.lessons.chapter2.getVocabFoodContent
import com.shadowings.gero.data.lessons.chapter2.getVocabFoodQuizContent
import com.shadowings.gero.data.lessons.chapter2.getVocabHumansContent
import com.shadowings.gero.data.lessons.chapter2.getVocabHumansQuizContent
import com.shadowings.gero.data.lessons.chapter2.humanNames
import com.shadowings.gero.data.lessons.chapter3.getEurekaContent
import com.shadowings.gero.data.lessons.chapter3.getFillerACapoComplementiContent
import com.shadowings.gero.data.lessons.chapter3.getFillerACapoComplementiQuizContent
import com.shadowings.gero.data.lessons.chapter3.getGenitivoDiretto2Content
import com.shadowings.gero.data.lessons.chapter3.getGenitivoDiretto2QuizContent
import com.shadowings.gero.data.lessons.chapter3.getGenitivoDirettoContent
import com.shadowings.gero.data.lessons.chapter3.getGenitivoDirettoQuizContent
import com.shadowings.gero.data.lessons.chapter3.getHieroVarieContent
import com.shadowings.gero.data.lessons.chapter3.getHieroVarieQuizContent
import com.shadowings.gero.data.lessons.chapter3.getListeNomiContent
import com.shadowings.gero.data.lessons.chapter3.getListeNomiQuizContent
import com.shadowings.gero.data.lessons.chapter3.getRipassoGenereNumeroContent
import com.shadowings.gero.data.lessons.chapter3.getRipassoGenereNumeroQuizContent
import com.shadowings.gero.data.lessons.chapter3.getVocabVarieContent
import com.shadowings.gero.data.lessons.chapter3.getVocabVarieQuizContent
import com.shadowings.gero.data.lessons.chapter3.vocabVarieWords
import com.shadowings.gero.data.lessons.chapter4.getApposizioneContent
import com.shadowings.gero.data.lessons.chapter4.getApposizioneQuizContent
import com.shadowings.gero.data.lessons.chapter4.getCartigliContent
import com.shadowings.gero.data.lessons.chapter4.getCartigliQuizContent
import com.shadowings.gero.data.lessons.chapter4.getGenitivoIndiretto2Content
import com.shadowings.gero.data.lessons.chapter4.getGenitivoIndiretto2QuizContent
import com.shadowings.gero.data.lessons.chapter4.getGenitivoIndirettoContent
import com.shadowings.gero.data.lessons.chapter4.getGenitivoIndirettoQuizContent
import com.shadowings.gero.data.lessons.chapter4.getMysteriousCartoucheContent
import com.shadowings.gero.data.lessons.chapter4.getRoyalNamesContent
import com.shadowings.gero.data.lessons.chapter4.getRoyalNamesFullContent
import com.shadowings.gero.data.lessons.chapter4.getRoyalNamesFullQuizContent
import com.shadowings.gero.data.lessons.chapter4.getRoyalNamesQuizContent
import com.shadowings.gero.data.lessons.chapter4.getTransliterationReadingContent
import com.shadowings.gero.data.lessons.chapter4.royalNameWordIds
import com.shadowings.gero.data.lessons.chapter5.getEndVerb1Content
import com.shadowings.gero.data.lessons.chapter5.getEndVerb1QuizContent
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs1Content
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs1QuizContent
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs2Content
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs2QuizContent
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs3Content
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs3QuizContent
import com.shadowings.gero.data.lessons.chapter5.getParticipiIntroContent
import com.shadowings.gero.data.lessons.chapter5.getParticipiIntroQuizContent
import com.shadowings.gero.data.lessons.chapter5.getRecapVerbiParticipiContent
import com.shadowings.gero.data.lessons.chapter5.getRecapVerbiParticipiQuizContent
import com.shadowings.gero.data.lessons.chapter5.getVerbiIntro1Content
import com.shadowings.gero.data.lessons.chapter5.getVerbiIntro1QuizContent
import com.shadowings.gero.data.lessons.chapter5.getVocabVerbs1Content
import com.shadowings.gero.data.lessons.chapter5.getVocabVerbs1QuizContent
import com.shadowings.gero.data.lessons.chapter5.getVocabVerbs2Content
import com.shadowings.gero.data.lessons.chapter5.getVocabVerbs2QuizContent
import com.shadowings.gero.data.lessons.chapter5.getVocabVerbs3Content
import com.shadowings.gero.data.lessons.chapter5.getVocabVerbs3QuizContent
import com.shadowings.gero.data.lessons.chapter5.vocabVerbs1WordIds
import com.shadowings.gero.data.lessons.chapter5.vocabVerbs2WordIds
import com.shadowings.gero.data.lessons.chapter5.vocabVerbs3WordIds
import com.shadowings.gero.data.lessons.chapter6.getClassiVerbaliContent
import com.shadowings.gero.data.lessons.chapter6.getClassiVerbaliQuizContent
import com.shadowings.gero.data.lessons.chapter6.getFormarVerbaContent
import com.shadowings.gero.data.lessons.chapter6.getFormarVerbaQuiz
import com.shadowings.gero.data.lessons.chapter6.getHieroVerbs4Content
import com.shadowings.gero.data.lessons.chapter6.getHieroVerbs4QuizContent
import com.shadowings.gero.data.lessons.chapter6.getRecapImperfettivoContent
import com.shadowings.gero.data.lessons.chapter6.getRecapImperfettivoQuiz
import com.shadowings.gero.data.lessons.chapter6.getSdmFIntroContent
import com.shadowings.gero.data.lessons.chapter6.getSdmFIntroQuizContent
import com.shadowings.gero.data.lessons.chapter6.getVocabPronomiSuffissiContent
import com.shadowings.gero.data.lessons.chapter6.getVocabPronomiSuffissiQuizContent
import com.shadowings.gero.data.lessons.chapter6.getVocabVerbs4Content
import com.shadowings.gero.data.lessons.chapter6.getVocabVerbs4QuizContent
import com.shadowings.gero.data.lessons.chapter6.vocabVerbs4WordIds
import com.shadowings.gero.data.lessons.chapter7.getHieroVso1Content
import com.shadowings.gero.data.lessons.chapter7.getHieroVso1QuizContent
import com.shadowings.gero.data.lessons.chapter7.getHieroVso2Content
import com.shadowings.gero.data.lessons.chapter7.getHieroVso2QuizContent
import com.shadowings.gero.data.lessons.chapter7.getHieroVso3Content
import com.shadowings.gero.data.lessons.chapter7.getHieroVso3QuizContent
import com.shadowings.gero.data.lessons.chapter7.getIntroVsoContent
import com.shadowings.gero.data.lessons.chapter7.getIntroVsoQuizContent
import com.shadowings.gero.data.lessons.chapter7.getSevenEndingContent
import com.shadowings.gero.data.lessons.chapter7.getSevenEndingQuizContent
import com.shadowings.gero.data.lessons.chapter7.getVocabVso1Content
import com.shadowings.gero.data.lessons.chapter7.getVocabVso1QuizContent
import com.shadowings.gero.data.lessons.chapter7.getVocabVso2Content
import com.shadowings.gero.data.lessons.chapter7.getVocabVso2QuizContent
import com.shadowings.gero.data.lessons.chapter7.getVocabVso3Content
import com.shadowings.gero.data.lessons.chapter7.getVocabVso3QuizContent
import com.shadowings.gero.data.lessons.chapter8.getDueOggettiContent
import com.shadowings.gero.data.lessons.chapter8.getDueOggettiQuizContent
import com.shadowings.gero.data.lessons.chapter8.getDueSoggettiContent
import com.shadowings.gero.data.lessons.chapter8.getDueSoggettiQuizContent
import com.shadowings.gero.data.lessons.chapter8.getEndingVsoContent
import com.shadowings.gero.data.lessons.chapter8.getEndingVsoQuizContent
import com.shadowings.gero.data.lessons.chapter8.getIntroVso8Content
import com.shadowings.gero.data.lessons.chapter8.getIntroVso8QuizContent
import com.shadowings.gero.data.lessons.chapter8.getOggettoFraseContent
import com.shadowings.gero.data.lessons.chapter8.getOggettoFraseQuizContent
import com.shadowings.gero.data.lessons.chapter8.getRecapVsoContent
import com.shadowings.gero.data.lessons.chapter8.getRecapVsoQuizContent
import com.shadowings.gero.data.lessons.chapter8.getSoggettoEsplicitoContent
import com.shadowings.gero.data.lessons.chapter8.getSoggettoEsplicitoQuizContent
import com.shadowings.gero.data.lessons.chapter9.getFacciamoIlPuntoContent
import com.shadowings.gero.data.lessons.chapter9.getFacciamoIlPuntoQuizContent
import com.shadowings.gero.data.lessons.chapter9.getFrasiAvverbialiContent
import com.shadowings.gero.data.lessons.chapter9.getFrasiAvverbialiQuizContent
import com.shadowings.gero.data.lessons.chapter9.getHieroVari1Content
import com.shadowings.gero.data.lessons.chapter9.getHieroVari1QuizContent
import com.shadowings.gero.data.lessons.chapter9.getHieroVari2Content
import com.shadowings.gero.data.lessons.chapter9.getHieroVari2QuizContent
import com.shadowings.gero.data.lessons.chapter9.getParticleIwContent
import com.shadowings.gero.data.lessons.chapter9.getParticleIwQuizContent
import com.shadowings.gero.data.lessons.chapter9.getPreposizioneMContent
import com.shadowings.gero.data.lessons.chapter9.getPreposizioneMQuizContent
import com.shadowings.gero.data.lessons.chapter9.getTuttoInsiemeOraContent
import com.shadowings.gero.data.lessons.chapter9.getTuttoInsiemeOraQuizContent
import com.shadowings.gero.data.lessons.chapter9.getVocabVari1Content
import com.shadowings.gero.data.lessons.chapter9.getVocabVari1QuizContent
import com.shadowings.gero.data.lessons.chapter9.getVocabVari2Content
import com.shadowings.gero.data.lessons.chapter9.getVocabVari2QuizContent
import com.shadowings.gero.data.lessons.placeholders.getHieroPlacesContent
import com.shadowings.gero.data.lessons.placeholders.getHieroPlacesQuizContent
import com.shadowings.gero.data.lessons.placeholders.getHieroVerbsContent
import com.shadowings.gero.data.lessons.placeholders.getHieroVerbsQuizContent
import com.shadowings.gero.data.lessons.placeholders.getVocabVerbsContent
import com.shadowings.gero.data.lessons.placeholders.getVocabVerbsQuizContent
import com.shadowings.gero.data.repository.DatabaseRepositoryImpl
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.GameConstants
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.ImageKeyboardContent
import com.shadowings.gero.domain.model.LessonIds
import com.shadowings.gero.domain.model.MultiPressContent
import com.shadowings.gero.domain.model.MultiPressPair
import com.shadowings.gero.domain.model.MultiSelectionContent
import com.shadowings.gero.domain.model.PhoneticKeyboardContent
import com.shadowings.gero.domain.model.SingleSelectionContent
import com.shadowings.gero.domain.model.TextTranslationContent
import com.shadowings.gero.domain.model.TrueFalseContent
import com.shadowings.gero.domain.model.WordSelectionContent
import com.shadowings.gero.domain.model.WordSpellingContent
import com.shadowings.gero.domain.repository.LessonContentRepository
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.question_type_multipress

class LessonContentDataSource : LessonContentRepository {

    override fun getExplanationContent(
        id: String,
        hiero: List<Hiero>,
        words: List<Word>,
        languageCode: String
    ): List<IExplanation> =
        when (id) {
            LessonIds.INTRO_HIEROGLYPHS -> getIntroductionHieroglyphsContent()
            LessonIds.INTRO_HIEROGLYPHS_2 -> getIntroHieroglyphs2Content()
            LessonIds.UNI_1 -> getUni1Content(hiero, words, languageCode)
            LessonIds.UNI_2 -> getUni2Content(hiero, words, languageCode)
            LessonIds.FAMOUS_NAMES -> getFamousNames(words, languageCode)
            LessonIds.CHAP1_CHAT -> getChap1ChatContent()
            LessonIds.PHONETIC_COMPLEMENTS -> getPhoneticComplementsContent()
            LessonIds.NUMBER_GENDER -> getNumberGenderContent()
            LessonIds.HIERO_FOOD -> getHieroFoodContent(hiero, words, languageCode)
            LessonIds.HIERO_FOOD_2 -> getHieroFood2Content(hiero, words, languageCode)
            LessonIds.VOCAB_FOOD -> getVocabFoodContent(words, languageCode)
            LessonIds.HIERO_ANIMALS -> getHieroAnimalsContent(hiero, words, languageCode)
            LessonIds.VOCAB_ANIMALS -> getVocabAnimalsContent(words, languageCode)
            LessonIds.HIERO_HUMANS -> getHieroHumansContent(hiero, words, languageCode)
            LessonIds.VOCAB_HUMANS -> getVocabHumansContent(words, languageCode)
            LessonIds.HIERO_PLACES -> getHieroPlacesContent()
            LessonIds.HIERO_VERBS -> getHieroVerbsContent(hiero, words, languageCode)
            LessonIds.VOCAB_VERBS -> getVocabVerbsContent(words, languageCode)
            LessonIds.HIERO_VERBS_1 -> getHieroVerbs1Content(hiero, words, languageCode)
            LessonIds.VOCAB_VERBS_1 -> getVocabVerbs1Content(words, languageCode)
            LessonIds.VERBI_INTRO_1 -> getVerbiIntro1Content()
            LessonIds.HIERO_VERBS_2 -> getHieroVerbs2Content(hiero, words, languageCode)
            LessonIds.VOCAB_VERBS_2 -> getVocabVerbs2Content(words, languageCode)
            LessonIds.HIERO_VERBS_3 -> getHieroVerbs3Content(hiero, words, languageCode)
            LessonIds.VOCAB_VERBS_3 -> getVocabVerbs3Content(words, languageCode)
            LessonIds.HIERO_VERBS_4 -> getHieroVerbs4Content(hiero, words, languageCode)
            LessonIds.VOCAB_VERBS_4 -> getVocabVerbs4Content(words, languageCode)
            LessonIds.PARTICIPI_INTRO -> getParticipiIntroContent()
            LessonIds.RECAP_VERBI_PARTICIPI -> getRecapVerbiParticipiContent()
            LessonIds.CHAP2_E_ORA -> getChap2EOraContent()
            LessonIds.RIPASSO_GENERE_NUMERO -> getRipassoGenereNumeroContent()
            LessonIds.GENITIVO_DIRETTO -> getGenitivoDirettoContent()
            LessonIds.GENITIVO_DIRETTO_2 -> getGenitivoDiretto2Content()
            LessonIds.FILLER_A_CAPO_COMPLEMENTI -> getFillerACapoComplementiContent()
            LessonIds.LISTE_NOMI -> getListeNomiContent()
            LessonIds.HIERO_VARIE -> getHieroVarieContent(hiero, words, languageCode)
            LessonIds.VOCAB_VARIE -> getVocabVarieContent(words, languageCode)
            LessonIds.EUREKA -> getEurekaContent()
            LessonIds.APPOSIZIONE -> getApposizioneContent()
            LessonIds.GENITIVO_INDIRETTO -> getGenitivoIndirettoContent()
            LessonIds.GENITIVO_INDIRETTO_2 -> getGenitivoIndiretto2Content()
            LessonIds.CARTIGLI -> getCartigliContent()
            LessonIds.ROYAL_NAMES -> getRoyalNamesContent(hiero, words, languageCode)
            LessonIds.MYSTERIOUS_CARTOUCHE -> getMysteriousCartoucheContent()
            LessonIds.ROYAL_NAMES_FULL -> getRoyalNamesFullContent(words, languageCode)
            LessonIds.TRANSLITERATION_READING -> getTransliterationReadingContent()
            LessonIds.END_VERB_1 -> getEndVerb1Content()
            LessonIds.SDM_F_INTRO -> getSdmFIntroContent()
            LessonIds.INTRO_VSO -> getIntroVsoContent()
            LessonIds.HIERO_VSO_1 -> getHieroVso1Content(hiero, words, languageCode)
            LessonIds.HIERO_VSO_2 -> getHieroVso2Content(hiero, words, languageCode)
            LessonIds.HIERO_VSO_3 -> getHieroVso3Content(hiero, words, languageCode)
            LessonIds.VOCAB_PRONOMI_SUFFISSI -> getVocabPronomiSuffissiContent(words, languageCode)
            LessonIds.CLASSI_VERBALI -> getClassiVerbaliContent()
            LessonIds.FORMARE_VERBI -> getFormarVerbaContent()
            LessonIds.RECAP_IMPERFETTIVO -> getRecapImperfettivoContent()
            LessonIds.VOCAB_VSO_1 -> getVocabVso1Content(words, languageCode)
            LessonIds.VOCAB_VSO_2 -> getVocabVso2Content(words, languageCode)
            LessonIds.VOCAB_VSO_3 -> getVocabVso3Content(words, languageCode)
            LessonIds.SEVEN_ENDING -> getSevenEndingContent()
            LessonIds.INTRO_VSO_8 -> getIntroVso8Content()
            LessonIds.SOGGETTO_ESPLICITO -> getSoggettoEsplicitoContent()
            LessonIds.OGGETTO_FRASE -> getOggettoFraseContent()
            LessonIds.DUE_SOGGETTI -> getDueSoggettiContent()
            LessonIds.DUE_OGGETTI -> getDueOggettiContent()
            LessonIds.RECAP_VSO -> getRecapVsoContent()
            LessonIds.ENDING_VSO -> getEndingVsoContent()
            LessonIds.PARTICLE_IW -> getParticleIwContent()
            LessonIds.FRASI_AVVERBIALI -> getFrasiAvverbialiContent()
            LessonIds.HIERO_VARI_1 -> getHieroVari1Content(hiero, words, languageCode)
            LessonIds.VOCAB_VARI_1 -> getVocabVari1Content(words, languageCode)
            LessonIds.HIERO_VARI_2 -> getHieroVari2Content(hiero, words, languageCode)
            LessonIds.VOCAB_VARI_2 -> getVocabVari2Content(words, languageCode)
            LessonIds.PREPOSIZIONE_M -> getPreposizioneMContent()
            LessonIds.TUTTO_INSIEME_ORA -> getTuttoInsiemeOraContent()
            LessonIds.FACCIAMO_IL_PUNTO -> getFacciamoIlPuntoContent()
            LessonIds.IL_GRANDE_RITORNO -> getIlGrandeRitornoContent()
            LessonIds.LA_TEORIA -> getLaTeoriaContent()
            LessonIds.IL_GENITIVO_DIRETTO -> getIlGenitivoDirettoContent()
            LessonIds.IL_GENITIVO_INDIRETTO -> getIlGenitivoIndirettoContent()
            LessonIds.VERBI_E_PARTICIPI -> getVerbiEParticipiContent()
            LessonIds.IL_TEMA_VERBALE_SDM_F -> getIlTemaVerbaleSdmFContent()
            LessonIds.LA_FORMA_VSO -> getLaFormaVsoContent()
            LessonIds.LE_FRASI_AVVERBIALI -> getLeFrasiAvverbialiContent()
            LessonIds.ECCO_FATTO -> getEccoFattoContent()
            LessonIds.UNA_DEFINIZIONE -> getUnaDefinizioneContent(hiero, words, languageCode)
            LessonIds.L_INFINITO -> getLInfinitoContent()
            LessonIds.VERBI_SOSTANTIVATI -> getVerbiSostantivatiContent()
            LessonIds.FRASI_CON_PRONOMI -> getFrasiConPronomiContent()
            LessonIds.FRASI_CON_SOGGETTO -> getFrasiConSoggettoContent()
            LessonIds.COMPLEMENTO_OGGETTO -> getFrasiComplOggettoContent()
            LessonIds.COMPLEMENTI_COMPLESSI -> getComplementiComplessiContent()
            LessonIds.RECAP_FRASI_PSEUDOVERBALI -> getRecapFrasiPseudoverbaliContent()
            LessonIds.LA_PAZIENZA_E_FINITA -> getLaPazienzaEFinitaContent()
            LessonIds.HIERO_FAMIGLIA_SOCIETA -> getHieroFamigliaSocietaContent(hiero, words, languageCode)
            LessonIds.VOCAB_FAMIGLIA_SOCIETA -> getVocabFamigliaSocietaContent(words, languageCode)
            LessonIds.HIERO_VERBI_VARI -> getHieroVerbiVariContent(hiero, words, languageCode)
            LessonIds.VOCAB_VERBI_VARI -> getVocabVerbiVariContent(words, languageCode)
            LessonIds.HIERO_OGGETTI_SACRI -> getHieroOggettiSacriContent(hiero, words, languageCode)
            LessonIds.VOCAB_OGGETTI_SACRI -> getVocabOggettiSacriContent(words, languageCode)
            LessonIds.HIERO_DEI_SOVRANI -> getHieroDeiSovraniContent(hiero, words, languageCode)
            LessonIds.VOCAB_DEI_SOVRANI -> getVocabDeiSovraniContent(words, languageCode)
            LessonIds.TORNIAMO_ALLA_GRAMMATICA -> getTorniamoAllaGrammaticaContent()
            LessonIds.LE_PREPOSIZIONI -> getLePreposizioniContent()
            LessonIds.PAROLE_DI_LUOGHI -> getParoleDiLuoghiContent(hiero, words, languageCode)
            LessonIds.PREPOSIZIONE_HR -> getPreposizioneHrContent()
            LessonIds.PREPOSIZIONE_M_LOCATIVA -> getPreposizioneMLocativaContent()
            LessonIds.PAROLE_DEL_TEMPO -> getParoleDelTempoContent(hiero, words, languageCode)
            LessonIds.PREPOSIZIONE_DR -> getPreposizioneDrContent()
            LessonIds.LA_FRASE_MISTERIOSA -> getLaFraseMisteriosaContent()
            LessonIds.LA_PARTICELLA_NI -> getLaParticellaNiContent()
            LessonIds.IL_VERBO_MA_I -> getIlVerboMaIContent()
            LessonIds.MI_TI_SRW -> getMiTiSrwContent()
            LessonIds.IL_DIMOSTRATIVO_PN -> getIlDimostrativoPnContent()
            LessonIds.RIECCOLO_DI_NUOVO -> getRieccoloDiNuovoContent()
            LessonIds.IL_SEGRETO_DELLA_PIRAMIDE -> getIlSegretoDellaPiramideContent()
            LessonIds.UN_ATTIMO -> getUnAttimoContent(hiero, languageCode)
            LessonIds.NOMI_IMPORTANTI -> getNomiImportantiContent()
            LessonIds.SIGNIFICATO_DEI_NOMI -> getSignificatoDeiNomiContent(hiero, languageCode)
            LessonIds.TRADUCIAMO_I_NOMI -> getTraduciamoINomiContent()
            LessonIds.NOMI_NOMI_NOMI -> getNomiNomiNomiContent()
            LessonIds.SEGNI_VARI -> getSegniVariContent(hiero, languageCode)
            LessonIds.NOMI_E_AGGETTIVI_1 -> getNomiEAggettivi1Content(words, languageCode)
            LessonIds.UN_SEGUACE_ECCELLENTE -> getUnSeguaceEccellenteContent()
            LessonIds.SEGNI_DEGLI_AGGETTIVI -> getSegniDegliAggettiviContent(hiero, languageCode)
            LessonIds.SCORTA_DI_AGGETTIVI -> getScortaDiAggettiviContent(words, languageCode)
            LessonIds.AGGETTIVI_GENERE -> getAggettiviGenereContent()
            LessonIds.AGGETTIVI_PLURALE -> getAggettiviPluraleContent()
            LessonIds.AGGETTIVO_SOSTANTIVATO -> getAggettivoSostantivatoContent()
            LessonIds.RIPASSINO_AGGETTIVI -> getRipassinoAggettiviContent()
            LessonIds.POSSESSIVO_SUFFISSO -> getPossessivoSuffissoContent(words, languageCode)
            LessonIds.SDM_F_CONGIUNTIVO -> getSdmFCongiuntivoContent()
            LessonIds.IN_VIAGGIO_SUL_NILO -> getInViaggioSulNiloContent()
            LessonIds.CAMBIO_DI_ROTTA -> getCambioDiRottaContent()
            else -> emptyList()
        }

    override fun getQuizOnlyWordIds(id: String): Set<String> =
        when (id) {
            LessonIds.NOMI_IMPORTANTI -> nomiImportantiQuizWordIds
            LessonIds.TRADUCIAMO_I_NOMI -> traduciamoINomiQuizWordIds
            LessonIds.NOMI_NOMI_NOMI -> nomiNomiNomiQuizWordIds
            else -> emptySet()
        }

    override fun getQuizContent(
        id: String,
        hiero: List<Hiero>,
        words: List<Word>,
        verbs: List<Verb>,
        languageCode: String,
        verbSentences: List<SentenceOptions>,
        distractorPool: DistractorPool?
    ): List<IQuizContent> = DistractorPool.using(distractorPool) {
        buildQuizContent(id, hiero, words, verbs, languageCode, verbSentences)
    }

    private fun buildQuizContent(
        id: String,
        hiero: List<Hiero>,
        words: List<Word>,
        verbs: List<Verb>,
        languageCode: String,
        verbSentences: List<SentenceOptions>
    ): List<IQuizContent> {
        if (id == LessonIds.DAILY_REVIEW) {
            return buildDailyReviewQuiz(hiero, words, verbs, languageCode, verbSentences)
        }

        val baseQuizzes = when (id) {
            LessonIds.RECAP_IMPERFETTIVO -> getRecapImperfettivoQuiz(words, verbs, languageCode)
            LessonIds.EUREKA -> {
                val baseQuizzes = (
                        getRipassoGenereNumeroQuizContent(words, languageCode).take(2)
                                + getGenitivoDirettoQuizContent(words, languageCode).take(2)
                                + getListeNomiQuizContent(words, languageCode).take(2)
                                + getVocabVarieQuizContent(
                            getVocabVarieContent(words, languageCode),
                            words,
                            languageCode
                        ).take(4)
                        ).shuffled().take(GameConstants.QUIZ_QUESTIONS_COUNT)

                val targetWordIds =
                    listOf(
                        "ORZO",
                        "DATTERO",
                        "VIPERA",
                        "LEONE",
                        "RE_DEL_BASSO_EGITTO",
                        "APICOLTORE"
                    )
                val targetWords =
                    targetWordIds.mapNotNull { targetId -> words.firstOrNull { it.id == targetId } }
                        .shuffled()
                        .take(4)

                val keyboardQuizzes = targetWords.map { word ->
                    TextTranslationContent(
                        hieroglyphs = word.gardiner,
                        correctPhrase = word.getMeaning(languageCode),
                        transliteration = word.reading
                    )
                }

                return baseQuizzes + keyboardQuizzes
            }

            LessonIds.INTRO_HIEROGLYPHS -> {
                getIntroductionHieroglyphsQuizContent()
            }

            LessonIds.INTRO_HIEROGLYPHS_2 -> {
                getIntroHieroglyphs2QuizContent()
            }

            LessonIds.UNI_1 -> {
                getUni_1QuizContent(hiero, words, languageCode)
            }

            LessonIds.UNI_2 -> {
                getUni_2QuizContent(hiero, words, languageCode)
            }

            LessonIds.FAMOUS_NAMES -> {
                getFamousNamesQuiz(words, languageCode)
            }

            LessonIds.CHAP1_CHAT -> {
                (
                        getIntroductionHieroglyphsQuizContent().shuffled().take(1)
                                + getIntroHieroglyphs2QuizContent().shuffled().take(1)
                                + getUni_1QuizContent(hiero, words, languageCode).shuffled().take(1)
                                + getUni_2QuizContent(hiero, words, languageCode).shuffled().take(1)
                                + getFamousNamesQuiz(words, languageCode).shuffled().take(6)
                        )
                    .shuffled()
            }

            LessonIds.NUMBER_GENDER -> {
                getNumberGenderQuizContent()
            }

            LessonIds.PHONETIC_COMPLEMENTS -> {
                getPhoneticComplementsQuizContent()
            }

            LessonIds.HIERO_FOOD -> {
                getHieroFoodQuizContent(hiero, words, languageCode)
            }

            LessonIds.HIERO_FOOD_2 -> {
                getHieroFood2QuizContent(hiero, words, languageCode)
            }

            LessonIds.VOCAB_FOOD -> {
                getVocabFoodQuizContent(
                    getVocabFoodContent(words, languageCode),
                    words,
                    languageCode
                )
            }

            LessonIds.HIERO_ANIMALS -> {
                getHieroAnimalsQuizContent(hiero, words, languageCode)
            }

            LessonIds.VOCAB_ANIMALS -> {
                getVocabAnimalsQuizContent(
                    getVocabAnimalsContent(words, languageCode),
                    words,
                    languageCode
                )
            }

            LessonIds.HIERO_HUMANS -> {
                getHieroHumansQuizContent(hiero, words, languageCode)
            }

            LessonIds.VOCAB_HUMANS -> {
                getVocabHumansQuizContent(
                    getVocabHumansContent(words, languageCode),
                    words,
                    languageCode
                )
            }

            LessonIds.HIERO_PLACES -> {
                getHieroPlacesQuizContent()
            }

            LessonIds.HIERO_VERBS -> {
                getHieroVerbsQuizContent(hiero, words, languageCode)
            }

            LessonIds.VOCAB_VERBS -> {
                val explanations = getVocabVerbsContent(words, languageCode)
                getVocabVerbsQuizContent(explanations, words, languageCode)
            }

            LessonIds.HIERO_VERBS_1 -> {
                getHieroVerbs1QuizContent(hiero, words, languageCode)
            }

            LessonIds.VOCAB_VERBS_1 -> {
                val explanations = getVocabVerbs1Content(words, languageCode)
                getVocabVerbs1QuizContent(explanations, words, languageCode)
            }

            LessonIds.VERBI_INTRO_1 -> {
                getVerbiIntro1QuizContent()
            }

            LessonIds.HIERO_VERBS_2 -> {
                getHieroVerbs2QuizContent(hiero, words, languageCode)
            }

            LessonIds.VOCAB_VERBS_2 -> {
                val explanations = getVocabVerbs2Content(words, languageCode)
                getVocabVerbs2QuizContent(explanations, words, languageCode)
            }

            LessonIds.HIERO_VERBS_3 -> {
                getHieroVerbs3QuizContent(hiero, words, languageCode)
            }

            LessonIds.VOCAB_VERBS_3 -> {
                val explanations = getVocabVerbs3Content(words, languageCode)
                getVocabVerbs3QuizContent(explanations, words, languageCode)
            }

            LessonIds.HIERO_VERBS_4 -> {
                getHieroVerbs4QuizContent(hiero, words, languageCode)
            }

            LessonIds.VOCAB_VERBS_4 -> {
                val explanations = getVocabVerbs4Content(words, languageCode)
                getVocabVerbs4QuizContent(explanations, words, languageCode)
            }

            LessonIds.PARTICIPI_INTRO -> {
                getParticipiIntroQuizContent()
            }

            LessonIds.RECAP_VERBI_PARTICIPI -> {
                getRecapVerbiParticipiQuizContent(words, languageCode)
            }

            LessonIds.END_VERB_1 -> {
                getEndVerb1QuizContent(hiero, words, languageCode)
            }

            LessonIds.SDM_F_INTRO -> {
                getSdmFIntroQuizContent()
            }

            LessonIds.INTRO_VSO -> {
                getIntroVsoQuizContent(hiero, words, languageCode)
            }

            LessonIds.HIERO_VSO_1 -> {
                getHieroVso1QuizContent(hiero, words, languageCode)
            }

            LessonIds.HIERO_VSO_2 -> {
                getHieroVso2QuizContent(hiero, words, languageCode)
            }

            LessonIds.HIERO_VSO_3 -> {
                getHieroVso3QuizContent(hiero, words, languageCode)
            }

            LessonIds.VOCAB_VSO_1 -> {
                val explanations = getVocabVso1Content(words, languageCode)
                getVocabVso1QuizContent(explanations, words, languageCode)
            }

            LessonIds.VOCAB_VSO_2 -> {
                val explanations = getVocabVso2Content(words, languageCode)
                getVocabVso2QuizContent(explanations, words, languageCode)
            }

            LessonIds.VOCAB_VSO_3 -> {
                val explanations = getVocabVso3Content(words, languageCode)
                getVocabVso3QuizContent(explanations, words, languageCode)
            }

            LessonIds.SEVEN_ENDING -> {
                getSevenEndingQuizContent(hiero, words, languageCode)
            }

            LessonIds.INTRO_VSO_8 -> {
                getIntroVso8QuizContent(hiero, words, verbs, languageCode)
            }

            LessonIds.SOGGETTO_ESPLICITO -> {
                getSoggettoEsplicitoQuizContent(hiero, words, verbs, languageCode, verbSentences)
            }

            LessonIds.OGGETTO_FRASE -> {
                getOggettoFraseQuizContent(hiero, words, verbs, languageCode, verbSentences)
            }

            LessonIds.DUE_SOGGETTI -> {
                getDueSoggettiQuizContent(hiero, words, verbs, languageCode, verbSentences)
            }

            LessonIds.DUE_OGGETTI -> {
                getDueOggettiQuizContent(hiero, words, verbs, languageCode, verbSentences)
            }

            LessonIds.RECAP_VSO -> {
                getRecapVsoQuizContent(languageCode, verbSentences)
            }

            LessonIds.ENDING_VSO -> {
                getEndingVsoQuizContent(languageCode, verbSentences)
            }

            LessonIds.PARTICLE_IW -> {
                getParticleIwQuizContent()
            }

            LessonIds.FRASI_AVVERBIALI -> {
                getFrasiAvverbialiQuizContent()
            }

            LessonIds.HIERO_VARI_1 -> {
                getHieroVari1QuizContent(hiero, words, languageCode)
            }

            LessonIds.VOCAB_VARI_1 -> {
                val explanations = getVocabVari1Content(words, languageCode)
                getVocabVari1QuizContent(explanations, words, languageCode)
            }

            LessonIds.HIERO_VARI_2 -> {
                getHieroVari2QuizContent(hiero, words, languageCode)
            }

            LessonIds.VOCAB_VARI_2 -> {
                val explanations = getVocabVari2Content(words, languageCode)
                getVocabVari2QuizContent(explanations, words, languageCode)
            }

            LessonIds.PREPOSIZIONE_M -> {
                getPreposizioneMQuizContent(hiero, words, languageCode)
            }

            LessonIds.TUTTO_INSIEME_ORA -> {
                getTuttoInsiemeOraQuizContent(words, languageCode)
            }

            LessonIds.FACCIAMO_IL_PUNTO -> {
                getFacciamoIlPuntoQuizContent(hiero, words, languageCode)
            }

            LessonIds.IL_GRANDE_RITORNO -> {
                getIlGrandeRitornoQuizContent(words, languageCode)
            }

            LessonIds.LA_TEORIA -> {
                getLaTeoriaQuizContent(hiero, words, languageCode)
            }

            LessonIds.IL_GENITIVO_DIRETTO -> {
                getIlGenitivoDirettoQuizContent(words, languageCode)
            }

            LessonIds.IL_GENITIVO_INDIRETTO -> {
                getIlGenitivoIndirettoQuizContent(words, languageCode)
            }

            LessonIds.VERBI_E_PARTICIPI -> {
                getVerbiEParticipiQuizContent(words, languageCode)
            }

            LessonIds.IL_TEMA_VERBALE_SDM_F -> {
                getIlTemaVerbaleSdmFQuizContent(words, verbs, languageCode)
            }

            LessonIds.LA_FORMA_VSO -> {
                getLaFormaVsoQuizContent(languageCode, verbSentences)
            }

            LessonIds.LE_FRASI_AVVERBIALI -> {
                getLeFrasiAvverbialiQuizContent(hiero, words, languageCode)
            }

            LessonIds.ECCO_FATTO -> {
                getEccoFattoQuizContent(hiero, words, languageCode)
            }

            LessonIds.UNA_DEFINIZIONE -> {
                getUnaDefinizioneQuizContent(words, languageCode)
            }

            LessonIds.L_INFINITO -> {
                getLInfinitoQuizContent(verbs, words, languageCode)
            }

            LessonIds.VERBI_SOSTANTIVATI -> {
                getVerbiSostantivatiQuizContent()
            }

            LessonIds.FRASI_CON_PRONOMI -> {
                getFrasiConPronomiQuizContent(verbs, words, languageCode, verbSentences)
            }

            LessonIds.FRASI_CON_SOGGETTO -> {
                getFrasiConSoggettoQuizContent(verbs, words, languageCode, verbSentences)
            }

            LessonIds.COMPLEMENTO_OGGETTO -> {
                getFrasiComplOggettoQuizContent(verbs, words, languageCode, verbSentences)
            }

            LessonIds.COMPLEMENTI_COMPLESSI -> {
                getComplementiComplessiQuizContent(verbs, words, languageCode, verbSentences)
            }

            LessonIds.RECAP_FRASI_PSEUDOVERBALI -> {
                getRecapFrasiPseudoverbaliQuizContent(verbs = verbs, words = words, languageCode = languageCode, verbSentences = verbSentences)
            }

            LessonIds.LA_PAZIENZA_E_FINITA -> {
                getLaPazienzaEFinitaQuizContent(verbs, words, languageCode, verbSentences = verbSentences)
            }

            LessonIds.HIERO_FAMIGLIA_SOCIETA -> {
                getHieroFamigliaSocietaQuizContent(hiero, words, languageCode)
            }

            LessonIds.VOCAB_FAMIGLIA_SOCIETA -> {
                val explanations = getVocabFamigliaSocietaContent(words, languageCode)
                getVocabFamigliaSocietaQuizContent(explanations, words, languageCode)
            }

            LessonIds.HIERO_VERBI_VARI -> {
                getHieroVerbiVariQuizContent(hiero, words, languageCode)
            }

            LessonIds.VOCAB_VERBI_VARI -> {
                val explanations = getVocabVerbiVariContent(words, languageCode)
                getVocabVerbiVariQuizContent(explanations, words, languageCode)
            }

            LessonIds.HIERO_OGGETTI_SACRI -> {
                getHieroOggettiSacriQuizContent(hiero, words, languageCode)
            }

            LessonIds.VOCAB_OGGETTI_SACRI -> {
                val explanations = getVocabOggettiSacriContent(words, languageCode)
                getVocabOggettiSacriQuizContent(explanations, words, languageCode)
            }

            LessonIds.HIERO_DEI_SOVRANI -> {
                getHieroDeiSovraniQuizContent(hiero, words, languageCode)
            }

            LessonIds.VOCAB_DEI_SOVRANI -> {
                val explanations = getVocabDeiSovraniContent(words, languageCode)
                getVocabDeiSovraniQuizContent(explanations, words, languageCode)
            }

            LessonIds.TORNIAMO_ALLA_GRAMMATICA -> {
                getTorniamoAllaGrammaticaQuizContent(verbs, words, languageCode, verbSentences = verbSentences)
            }

            LessonIds.LE_PREPOSIZIONI -> {
                getLePreposizioniQuizContent(verbs, words, languageCode, verbSentences = verbSentences)
            }

            LessonIds.PAROLE_DI_LUOGHI -> {
                getParoleDiLuoghiQuizContent(hiero, words, languageCode)
            }

            LessonIds.PREPOSIZIONE_HR -> {
                getPreposizioneHrQuizContent(verbs, words, languageCode, verbSentences = verbSentences)
            }

            LessonIds.PREPOSIZIONE_M_LOCATIVA -> {
                getPreposizioneMLocativaQuizContent(verbs, words, languageCode, verbSentences = verbSentences)
            }

            LessonIds.PAROLE_DEL_TEMPO -> {
                getParoleDelTempoQuizContent(hiero, words, languageCode)
            }

            LessonIds.PREPOSIZIONE_DR -> {
                getPreposizioneDrQuizContent(verbs, words, languageCode, verbSentences = verbSentences)
            }

            LessonIds.LA_FRASE_MISTERIOSA -> {
                getLaFraseMisteriosaQuizContent(hiero, verbs, words, languageCode, verbSentences = verbSentences)
            }

            LessonIds.LA_PARTICELLA_NI -> {
                getLaParticellaNiQuizContent(hiero, words, verbs, languageCode, verbSentences = verbSentences)
            }

            LessonIds.IL_VERBO_MA_I -> {
                getIlVerboMaIQuizContent(hiero, words, verbs, languageCode, verbSentences = verbSentences)
            }

            LessonIds.MI_TI_SRW -> {
                getMiTiSrwQuizContent(hiero, words, verbs, languageCode, verbSentences = verbSentences)
            }

            LessonIds.IL_DIMOSTRATIVO_PN -> {
                getIlDimostrativoPnQuizContent(hiero, words, verbs, languageCode, verbSentences = verbSentences)
            }

            LessonIds.RIECCOLO_DI_NUOVO -> {
                getRieccoloDiNuovoQuizContent(hiero, words, verbs, languageCode, verbSentences = verbSentences)
            }

            LessonIds.IL_SEGRETO_DELLA_PIRAMIDE -> {
                getIlSegretoDellaPiramideQuizContent(hiero, words, verbs, languageCode, verbSentences = verbSentences)
            }

            LessonIds.UN_ATTIMO -> {
                getUnAttimoQuizContent(hiero, languageCode)
            }

            LessonIds.NOMI_IMPORTANTI -> getNomiImportantiQuizContent(words)

            LessonIds.SIGNIFICATO_DEI_NOMI -> {
                getSignificatoDeiNomiQuizContent(hiero, words, verbs, languageCode, verbSentences = verbSentences)
            }

            LessonIds.TRADUCIAMO_I_NOMI -> {
                getTraduciamoINomiQuizContent(hiero, words, verbs, languageCode, verbSentences = verbSentences)
            }

            LessonIds.NOMI_NOMI_NOMI -> {
                getNomiNomiNomiQuizContent(hiero, words, verbs, languageCode, verbSentences = verbSentences)
            }

            LessonIds.SEGNI_VARI -> {
                getSegniVariQuizContent(hiero, languageCode)
            }

            LessonIds.NOMI_E_AGGETTIVI_1 -> getNomiEAggettivi1QuizContent(words, languageCode)

            LessonIds.SEGNI_DEGLI_AGGETTIVI -> getSegniDegliAggettiviQuizContent(hiero, languageCode)

            LessonIds.SCORTA_DI_AGGETTIVI -> getScortaDiAggettiviQuizContent(words, languageCode)

            LessonIds.AGGETTIVI_GENERE -> getAggettiviGenereQuizContent(words, languageCode)

            LessonIds.AGGETTIVI_PLURALE -> getAggettiviPluraleQuizContent(words, languageCode)

            LessonIds.AGGETTIVO_SOSTANTIVATO -> getAggettivoSostantivatoQuizContent(words, languageCode)

            LessonIds.RIPASSINO_AGGETTIVI -> getRipassinoAggettiviQuizContent(hiero, words, languageCode)

            LessonIds.POSSESSIVO_SUFFISSO -> getPossessivoSuffissoQuizContent(words, languageCode)

            LessonIds.IN_VIAGGIO_SUL_NILO -> getInViaggioSulNiloQuizContent(words, verbs, languageCode, verbSentences)

            LessonIds.CAMBIO_DI_ROTTA -> getCambioDiRottaQuizContent(words, verbs, languageCode, verbSentences)

            LessonIds.UN_SEGUACE_ECCELLENTE -> {
                getUnSeguaceEccellenteQuizContent(hiero, words, verbs, languageCode, verbSentences = verbSentences)
            }

            LessonIds.VOCAB_PRONOMI_SUFFISSI -> {
                val explanations = getVocabPronomiSuffissiContent(words, languageCode)
                getVocabPronomiSuffissiQuizContent(explanations, words, languageCode)
            }

            LessonIds.CLASSI_VERBALI -> {
                getClassiVerbaliQuizContent()
            }

            LessonIds.CHAP2_E_ORA -> {
                (
                        getNumberGenderQuizContent().take(1)
                                + getVocabFoodQuizContent(
                            getVocabFoodContent(words, languageCode),
                            words,
                            languageCode
                        ).take(3)
                                + getVocabAnimalsQuizContent(
                            getVocabAnimalsContent(words, languageCode),
                            words,
                            languageCode
                        ).take(
                            3
                        )
                                + getVocabHumansQuizContent(
                            getVocabHumansContent(words, languageCode),
                            words,
                            languageCode
                        ).take(3)
                        )
            }

            LessonIds.GENITIVO_DIRETTO -> {
                getGenitivoDirettoQuizContent(
                    words = words,
                    languageCode = languageCode
                )
            }

            LessonIds.GENITIVO_DIRETTO_2 -> {
                getGenitivoDiretto2QuizContent(words = words, languageCode = languageCode)
            }

            LessonIds.RIPASSO_GENERE_NUMERO -> {
                getRipassoGenereNumeroQuizContent(words = words, languageCode = languageCode)
            }

            LessonIds.LISTE_NOMI -> {
                getListeNomiQuizContent(words = words, languageCode = languageCode)
            }

            LessonIds.HIERO_VARIE -> {
                getHieroVarieQuizContent(hiero = hiero, words = words, languageCode = languageCode)
            }

            LessonIds.VOCAB_VARIE -> {
                getVocabVarieQuizContent(
                    explanations = getVocabVarieContent(words, languageCode),
                    words = words,
                    languageCode = languageCode
                )
            }

            LessonIds.FILLER_A_CAPO_COMPLEMENTI -> {
                getFillerACapoComplementiQuizContent()
            }

            LessonIds.APPOSIZIONE -> {
                getApposizioneQuizContent(words = words, languageCode = languageCode)
            }

            LessonIds.GENITIVO_INDIRETTO -> {
                getGenitivoIndirettoQuizContent(words = words, languageCode = languageCode)
            }

            LessonIds.GENITIVO_INDIRETTO_2 -> {
                getGenitivoIndiretto2QuizContent(words = words, languageCode = languageCode)
            }

            LessonIds.CARTIGLI -> {
                getCartigliQuizContent()
            }

            LessonIds.ROYAL_NAMES -> {
                getRoyalNamesQuizContent(hiero = hiero, words = words, languageCode = languageCode)
            }

            LessonIds.MYSTERIOUS_CARTOUCHE, LessonIds.TRANSLITERATION_READING -> {
                getGenitivoDiretto2QuizContent(
                    words = words,
                    languageCode = languageCode
                ).shuffled()
                    .take(4) +
                        getGenitivoIndiretto2QuizContent(
                            words = words,
                            languageCode = languageCode
                        ).shuffled().take(4) +
                        getListeNomiQuizContent(
                            words = words,
                            languageCode = languageCode
                        ).shuffled().take(4)
            }

            LessonIds.ROYAL_NAMES_FULL -> {
                getRoyalNamesFullQuizContent(words = words, languageCode = languageCode)
            }

            LessonIds.FORMARE_VERBI -> getFormarVerbaQuiz(words, verbs, languageCode)

            else -> {
                emptyList()
            }
        }

        val chapterSevenLessonIds = listOf(
            LessonIds.INTRO_VSO,
            LessonIds.HIERO_VSO_1,
            LessonIds.VOCAB_VSO_1,
            LessonIds.HIERO_VSO_2,
            LessonIds.VOCAB_VSO_2,
            LessonIds.HIERO_VSO_3,
            LessonIds.VOCAB_VSO_3
        )

        return if (id in chapterSevenLessonIds) {
            val normalList = baseQuizzes.filter { it !is MultiPressContent }.shuffled()
            val multipressList = baseQuizzes.filterIsInstance<MultiPressContent>()
            val multipress = if (multipressList.isNotEmpty()) {
                multipressList.random()
            } else {
                generateOldWordsMultiPress(words, languageCode)
            }
            (normalList.take(GameConstants.QUIZ_QUESTIONS_COUNT - 1) + multipress).shuffled()
        } else {
            // A lesson with inscription photos always asks at least one of them: otherwise a single
            // photo among ~30 generated vocab questions would rarely make the 10-question cut.
            val guaranteedImage = baseQuizzes.filterIsInstance<ImageKeyboardContent>().randomOrNull()
            val others = baseQuizzes.filterNot { it === guaranteedImage }.shuffled()
            (listOfNotNull(guaranteedImage) + others).take(GameConstants.QUIZ_QUESTIONS_COUNT).shuffled()
        }
    }

    // Kotlin forbids an override from repeating a base default value, so this overload exists
    // purely to keep the pre-existing 5-arg call sites (this class's own tests) compiling —
    // it's equivalent to calling the 6-arg override with the interface's own default.
    fun getQuizContent(
        id: String,
        hiero: List<Hiero>,
        words: List<Word>,
        verbs: List<Verb>,
        languageCode: String
    ): List<IQuizContent> = getQuizContent(id, hiero, words, verbs, languageCode, DatabaseRepositoryImpl.verbSentences, null)

    private fun generateOldWordsMultiPress(
        words: List<Word>,
        languageCode: String
    ): MultiPressContent {
        val oldWordIds = famousNames + foodNames + animalNames + humanNames + vocabVarieWords +
                royalNameWordIds + vocabVerbs1WordIds + vocabVerbs2WordIds + vocabVerbs3WordIds + vocabVerbs4WordIds

        val selectedWords = words.filter { it.id in oldWordIds }
            .shuffled()
            .take(4)

        val pairs = selectedWords.map {
            MultiPressPair(
                hieroglyphs = it.gardiner,
                meaning = it.getMeaning(languageCode)
            )
        }

        return MultiPressContent(
            pairs = pairs,
            prompt = Res.string.question_type_multipress
        )
    }

    /**
     * Builds the daily review deck WITHOUT generating every lesson in the game: each candidate
     * lesson generator is wrapped as a lazy [DailyReviewProvider] and only actually invoked when
     * picked, at most once (memoized in [cache]). We pick one provider per required quiz type
     * (randomized among the providers that offer it, for variety across days), then fill the
     * remaining slots from what those already-called providers produced — calling a few more
     * providers only if that's not enough. This replaces the old approach of eagerly calling
     * ~50 lesson functions (several of which redundantly re-called each other) and sampling 10
     * out of the resulting pool, which made opening the daily review quiz noticeably slow.
     */
    private fun buildDailyReviewQuiz(
        hiero: List<Hiero>,
        words: List<Word>,
        verbs: List<Verb>,
        languageCode: String,
        verbSentences: List<SentenceOptions>
    ): List<IQuizContent> {
        val providers = dailyReviewProviders(hiero, words, verbs, languageCode, verbSentences)
        val cache = mutableMapOf<DailyReviewProvider, List<IQuizContent>>()
        // Multiple-choice (MultiSelectionContent) is excluded from the review deck: only a
        // couple of lessons produce it, each with a handful of hardcoded questions, so that pool
        // is too small once it's reused across the whole review deck.
        fun resultsFor(provider: DailyReviewProvider) =
            cache.getOrPut(provider) {
                try {
                    provider.generate().filterNot { it is MultiSelectionContent }
                } catch (_: Exception) {
                    emptyList()
                }
            }

        val guaranteed = mutableListOf<IQuizContent>()
        val used = mutableSetOf<IQuizContent>()
        DailyReviewQuizType.entries.forEach { type ->
            val match = providers.filter { type in it.types }.shuffled()
                .firstNotNullOfOrNull { provider ->
                    resultsFor(provider).firstOrNull { type.matches(it) && it !in used }
                }
            if (match != null) {
                guaranteed += match
                used += match
            }
        }

        val fillCount = (GameConstants.QUIZ_QUESTIONS_COUNT - guaranteed.size).coerceAtLeast(0)
        var fillCandidates = cache.values.flatten().filterNot { it in used }
        if (fillCandidates.size < fillCount) {
            providers.filterNot { cache.containsKey(it) }.shuffled().take(4)
                .forEach { resultsFor(it) }
            fillCandidates = cache.values.flatten().filterNot { it in used }
        }

        return (guaranteed + fillCandidates.shuffled().take(fillCount)).shuffled()
    }
}

private enum class DailyReviewQuizType {
    PHONETIC_KEYBOARD, TRUE_FALSE, MULTI_SELECTION, MULTI_PRESS,
    SINGLE_SELECTION, WORD_SELECTION, TEXT_TRANSLATION, WORD_SPELLING, IMAGE_KEYBOARD;

    fun matches(item: IQuizContent): Boolean = when (this) {
        PHONETIC_KEYBOARD -> item is PhoneticKeyboardContent
        TRUE_FALSE -> item is TrueFalseContent
        MULTI_SELECTION -> item is MultiSelectionContent
        MULTI_PRESS -> item is MultiPressContent
        SINGLE_SELECTION -> item is SingleSelectionContent
        WORD_SELECTION -> item is WordSelectionContent
        TEXT_TRANSLATION -> item is TextTranslationContent
        WORD_SPELLING -> item is WordSpellingContent
        IMAGE_KEYBOARD -> item is ImageKeyboardContent
    }
}

private class DailyReviewProvider(
    val types: Set<DailyReviewQuizType>,
    val generate: () -> List<IQuizContent>
)

/**
 * One entry per distinct lesson generator that's safe/cheap to call for the daily review deck.
 * Deliberately excludes lessons that just re-wrap other lessons already listed here (e.g.
 * `getIlGrandeRitornoQuizContent`, `getFacciamoIlPuntoQuizContent` and its chapter-10 callers,
 * `getIlGenitivoIndirettoQuizContent`, `getIlGenitivoDirettoQuizContent`, `getLaTeoriaQuizContent`,
 * `getVerbiEParticipiQuizContent`/`getIlTemaVerbaleSdmFQuizContent` (pure aliases),
 * `getSevenEndingQuizContent`, `getLaPazienzaEFinitaQuizContent` (a thin wrapper around
 * `getRecapFrasiPseudoverbaliQuizContent`, already listed below) and
 * `getLaFraseMisteriosaQuizContent` (which re-wraps chapter 13's individual quiz functions)) —
 * including them would only make the same words get reprocessed
 * for no new content, which is what made the old eager-pool approach so much heavier than it
 * needed to be.
 */
private fun dailyReviewProviders(
    hiero: List<Hiero>,
    words: List<Word>,
    verbs: List<Verb>,
    languageCode: String,
    verbSentences: List<SentenceOptions>
): List<DailyReviewProvider> {
    fun vocab(types: Set<DailyReviewQuizType>, generate: () -> List<IQuizContent>) =
        DailyReviewProvider(
            types + setOf(
                DailyReviewQuizType.PHONETIC_KEYBOARD,
                DailyReviewQuizType.SINGLE_SELECTION,
                DailyReviewQuizType.WORD_SPELLING
            ), generate
        )

    return listOf(
        // Chapter 1-4
        vocab(setOf(DailyReviewQuizType.IMAGE_KEYBOARD)) { getFamousNamesQuiz(words, languageCode) },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.TRUE_FALSE,
                DailyReviewQuizType.MULTI_SELECTION
            )
        ) {
            getIntroductionHieroglyphsQuizContent()
        },
        DailyReviewProvider(setOf(DailyReviewQuizType.TRUE_FALSE)) {
            getIntroHieroglyphs2QuizContent()
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.TRUE_FALSE,
                DailyReviewQuizType.MULTI_SELECTION
            )
        ) {
            getNumberGenderQuizContent()
        },
        vocab(setOf(DailyReviewQuizType.IMAGE_KEYBOARD)) {
            getVocabFoodQuizContent(
                getVocabFoodContent(words, languageCode),
                words,
                languageCode
            )
        },
        vocab(setOf(DailyReviewQuizType.IMAGE_KEYBOARD)) {
            getVocabAnimalsQuizContent(
                getVocabAnimalsContent(words, languageCode),
                words,
                languageCode
            )
        },
        vocab(setOf(DailyReviewQuizType.IMAGE_KEYBOARD)) {
            getVocabHumansQuizContent(
                getVocabHumansContent(words, languageCode),
                words,
                languageCode
            )
        },
        DailyReviewProvider(setOf(DailyReviewQuizType.WORD_SELECTION)) {
            getGenitivoDirettoQuizContent(words, languageCode)
        },
        DailyReviewProvider(setOf(DailyReviewQuizType.TEXT_TRANSLATION)) {
            getGenitivoDiretto2QuizContent(words, languageCode)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.WORD_SELECTION,
                DailyReviewQuizType.TEXT_TRANSLATION
            )
        ) {
            getListeNomiQuizContent(words, languageCode)
        },
        vocab(setOf(DailyReviewQuizType.IMAGE_KEYBOARD)) {
            getVocabVarieQuizContent(
                getVocabVarieContent(words, languageCode),
                words,
                languageCode
            )
        },
        DailyReviewProvider(setOf(DailyReviewQuizType.TEXT_TRANSLATION)) {
            getApposizioneQuizContent(words, languageCode)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.WORD_SELECTION,
                DailyReviewQuizType.TEXT_TRANSLATION
            )
        ) {
            getGenitivoIndiretto2QuizContent(words, languageCode)
        },
        vocab(setOf(DailyReviewQuizType.IMAGE_KEYBOARD)) { getRoyalNamesFullQuizContent(words, languageCode) },
        // Chapter 12 is live (wired into ChaptersJson.defaultChapters), so its VOCABULARY lessons
        // are included here like any other chapter's; the SYMBOLS lessons (HIERO_*) aren't, matching
        // the rest of this list, which only reviews vocabulary lessons, not sign-teaching ones.
        vocab(emptySet()) {
            getVocabFamigliaSocietaQuizContent(
                getVocabFamigliaSocietaContent(words, languageCode),
                words,
                languageCode
            )
        },
        vocab(emptySet()) {
            getVocabVerbiVariQuizContent(
                getVocabVerbiVariContent(words, languageCode),
                words,
                languageCode
            )
        },
        vocab(emptySet()) {
            getVocabOggettiSacriQuizContent(
                getVocabOggettiSacriContent(words, languageCode),
                words,
                languageCode
            )
        },
        vocab(emptySet()) {
            getVocabDeiSovraniQuizContent(
                getVocabDeiSovraniContent(words, languageCode),
                words,
                languageCode
            )
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.PHONETIC_KEYBOARD,
                DailyReviewQuizType.WORD_SELECTION,
                DailyReviewQuizType.TEXT_TRANSLATION
            )
        ) {
            getTorniamoAllaGrammaticaQuizContent(verbs, words, languageCode, verbSentences = verbSentences)
        },
        DailyReviewProvider(setOf(DailyReviewQuizType.SINGLE_SELECTION)) {
            getRipassoGenereNumeroQuizContent(words, languageCode)
        },

        // Chapter 5-6
        vocab(emptySet()) {
            getVocabVerbs1QuizContent(
                getVocabVerbs1Content(words, languageCode),
                words,
                languageCode
            )
        },
        vocab(emptySet()) {
            getVocabVerbs2QuizContent(
                getVocabVerbs2Content(words, languageCode),
                words,
                languageCode
            )
        },
        vocab(emptySet()) {
            getVocabVerbs3QuizContent(
                getVocabVerbs3Content(words, languageCode),
                words,
                languageCode
            )
        },
        DailyReviewProvider(setOf(DailyReviewQuizType.SINGLE_SELECTION)) {
            getRecapVerbiParticipiQuizContent(words, languageCode)
        },
        vocab(emptySet()) {
            getVocabPronomiSuffissiQuizContent(
                getVocabPronomiSuffissiContent(
                    words,
                    languageCode
                ), words, languageCode
            )
        },
        DailyReviewProvider(setOf(DailyReviewQuizType.TRUE_FALSE)) {
            getClassiVerbaliQuizContent()
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.PHONETIC_KEYBOARD,
                DailyReviewQuizType.SINGLE_SELECTION
            )
        ) {
            getFormarVerbaQuiz(words, verbs, languageCode)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.MULTI_PRESS,
                DailyReviewQuizType.PHONETIC_KEYBOARD,
                DailyReviewQuizType.TEXT_TRANSLATION
            )
        ) {
            getRecapImperfettivoQuiz(words, verbs, languageCode)
        },
        vocab(emptySet()) {
            getVocabVerbs4QuizContent(
                getVocabVerbs4Content(words, languageCode),
                words,
                languageCode
            )
        },

        // Chapter 7-8
        vocab(emptySet()) {
            getVocabVso1QuizContent(
                getVocabVso1Content(words, languageCode),
                words,
                languageCode
            )
        },
        vocab(emptySet()) {
            getVocabVso2QuizContent(
                getVocabVso2Content(words, languageCode),
                words,
                languageCode
            )
        },
        vocab(emptySet()) {
            getVocabVso3QuizContent(
                getVocabVso3Content(words, languageCode),
                words,
                languageCode
            )
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.PHONETIC_KEYBOARD,
                DailyReviewQuizType.WORD_SELECTION
            )
        ) {
            getSoggettoEsplicitoQuizContent(hiero, words, verbs, languageCode, verbSentences)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.PHONETIC_KEYBOARD,
                DailyReviewQuizType.WORD_SELECTION
            )
        ) {
            getOggettoFraseQuizContent(hiero, words, verbs, languageCode, verbSentences)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.PHONETIC_KEYBOARD,
                DailyReviewQuizType.WORD_SELECTION
            )
        ) {
            getDueSoggettiQuizContent(hiero, words, verbs, languageCode, verbSentences)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.PHONETIC_KEYBOARD,
                DailyReviewQuizType.WORD_SELECTION
            )
        ) {
            getDueOggettiQuizContent(hiero, words, verbs, languageCode, verbSentences)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.PHONETIC_KEYBOARD,
                DailyReviewQuizType.WORD_SELECTION
            )
        ) {
            getRecapVsoQuizContent(languageCode, verbSentences)
        },
        DailyReviewProvider(setOf(DailyReviewQuizType.TEXT_TRANSLATION)) {
            getLaFormaVsoQuizContent(languageCode, verbSentences)
        },

        // Chapter 9
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.TRUE_FALSE,
                DailyReviewQuizType.SINGLE_SELECTION
            )
        ) {
            getParticleIwQuizContent()
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.TRUE_FALSE,
                DailyReviewQuizType.SINGLE_SELECTION
            )
        ) {
            getFrasiAvverbialiQuizContent()
        },
        vocab(emptySet()) {
            getVocabVari1QuizContent(
                getVocabVari1Content(words, languageCode),
                words,
                languageCode
            )
        },
        vocab(setOf(DailyReviewQuizType.IMAGE_KEYBOARD)) {
            getVocabVari2QuizContent(
                getVocabVari2Content(words, languageCode),
                words,
                languageCode
            )
        },
        DailyReviewProvider(setOf(DailyReviewQuizType.TRUE_FALSE)) {
            getPreposizioneMQuizContent(hiero, words, languageCode)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.PHONETIC_KEYBOARD,
                DailyReviewQuizType.TEXT_TRANSLATION
            )
        ) {
            getTuttoInsiemeOraQuizContent(words, languageCode)
        },

        // Chapter 11
        DailyReviewProvider(setOf(DailyReviewQuizType.TRUE_FALSE)) {
            getUnaDefinizioneQuizContent(words, languageCode)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.SINGLE_SELECTION,
                DailyReviewQuizType.TEXT_TRANSLATION
            )
        ) {
            getLInfinitoQuizContent(verbs, words, languageCode)
        },
        DailyReviewProvider(setOf(DailyReviewQuizType.TRUE_FALSE)) {
            getVerbiSostantivatiQuizContent()
        },
        DailyReviewProvider(setOf(DailyReviewQuizType.SINGLE_SELECTION)) {
            getFrasiConPronomiQuizContent(verbs, words, languageCode, verbSentences)
        },
        DailyReviewProvider(setOf(DailyReviewQuizType.SINGLE_SELECTION)) {
            getFrasiConSoggettoQuizContent(verbs, words, languageCode, verbSentences)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.PHONETIC_KEYBOARD,
                DailyReviewQuizType.SINGLE_SELECTION
            )
        ) {
            getFrasiComplOggettoQuizContent(verbs, words, languageCode, verbSentences)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.PHONETIC_KEYBOARD,
                DailyReviewQuizType.SINGLE_SELECTION
            )
        ) {
            getComplementiComplessiQuizContent(verbs, words, languageCode, verbSentences)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.PHONETIC_KEYBOARD,
                DailyReviewQuizType.WORD_SELECTION,
                DailyReviewQuizType.TEXT_TRANSLATION
            )
        ) {
            getRecapFrasiPseudoverbaliQuizContent(verbs = verbs, words = words, languageCode = languageCode, verbSentences = verbSentences)
        },

        // Chapter 13
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.SINGLE_SELECTION,
                DailyReviewQuizType.WORD_SELECTION,
                DailyReviewQuizType.TEXT_TRANSLATION,
                DailyReviewQuizType.PHONETIC_KEYBOARD
            )
        ) {
            getLePreposizioniQuizContent(verbs, words, languageCode, verbSentences = verbSentences)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.SINGLE_SELECTION,
                DailyReviewQuizType.WORD_SELECTION
            )
        ) {
            getPreposizioneHrQuizContent(verbs, words, languageCode, verbSentences = verbSentences)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.SINGLE_SELECTION,
                DailyReviewQuizType.WORD_SELECTION
            )
        ) {
            getPreposizioneMLocativaQuizContent(verbs, words, languageCode, verbSentences = verbSentences)
        },
        vocab(setOf(DailyReviewQuizType.MULTI_PRESS)) {
            getParoleDelTempoQuizContent(hiero, words, languageCode)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.SINGLE_SELECTION,
                DailyReviewQuizType.WORD_SELECTION
            )
        ) {
            getPreposizioneDrQuizContent(verbs, words, languageCode, verbSentences = verbSentences)
        },

        // Chapter 14: getIlVerboMaIQuizContent and getIlSegretoDellaPiramideQuizContent are pure
        // aliases of LaParticellaNi/RieccoloDiNuovo, and getIlDimostrativoPnQuizContent is empty.
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.PHONETIC_KEYBOARD,
                DailyReviewQuizType.WORD_SELECTION,
                DailyReviewQuizType.TEXT_TRANSLATION
            )
        ) {
            getLaParticellaNiQuizContent(hiero, words, verbs, languageCode, verbSentences = verbSentences)
        },
        DailyReviewProvider(setOf(DailyReviewQuizType.SINGLE_SELECTION)) {
            getMiTiSrwQuizContent(hiero, words, verbs, languageCode, verbSentences = verbSentences)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.MULTI_PRESS,
                DailyReviewQuizType.PHONETIC_KEYBOARD,
                DailyReviewQuizType.WORD_SELECTION,
                DailyReviewQuizType.TEXT_TRANSLATION
            )
        ) {
            getRieccoloDiNuovoQuizContent(hiero, words, verbs, languageCode, verbSentences = verbSentences)
        },

        // Chapter 15: UN_ATTIMO and SIGNIFICATO_DEI_NOMI are sign-teaching lessons, left out like the
        // other HIERO_* ones (so is SEGNI_VARI); TRADUCIAMO_I_NOMI and NOMI_NOMI_NOMI contribute only their
        // new cartouche photos.
        DailyReviewProvider(setOf(DailyReviewQuizType.IMAGE_KEYBOARD)) {
            getNomiImportantiQuizContent(words)
        },
        DailyReviewProvider(setOf(DailyReviewQuizType.IMAGE_KEYBOARD)) {
            getTraduciamoINomiImageQuizContent(words)
        },
        DailyReviewProvider(setOf(DailyReviewQuizType.IMAGE_KEYBOARD)) {
            getNomiNomiNomiImageQuizContent(words)
        },
        vocab(setOf(DailyReviewQuizType.MULTI_PRESS)) {
            getNomiEAggettivi1QuizContent(words, languageCode)
        },

        // Chapter 16: SEGNI_DEGLI_AGGETTIVI is a sign-teaching lesson, left out like SEGNI_VARI.
        vocab(setOf(DailyReviewQuizType.MULTI_PRESS)) {
            getScortaDiAggettiviQuizContent(words, languageCode)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.WORD_SELECTION,
                DailyReviewQuizType.SINGLE_SELECTION,
                DailyReviewQuizType.TRUE_FALSE
            )
        ) {
            getAggettiviGenereQuizContent(words, languageCode)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.WORD_SELECTION,
                DailyReviewQuizType.SINGLE_SELECTION,
                DailyReviewQuizType.TRUE_FALSE
            )
        ) {
            getAggettiviPluraleQuizContent(words, languageCode)
        },
        DailyReviewProvider(setOf(DailyReviewQuizType.SINGLE_SELECTION, DailyReviewQuizType.TRUE_FALSE)) {
            getAggettivoSostantivatoQuizContent(words, languageCode)
        },
        DailyReviewProvider(
            setOf(
                DailyReviewQuizType.WORD_SELECTION,
                DailyReviewQuizType.SINGLE_SELECTION,
                DailyReviewQuizType.TRUE_FALSE
            )
        ) {
            getPossessivoSuffissoQuizContent(words, languageCode)
        },
    )
}

